import { render, staticRenderFns } from "./AgentSubTitle.vue?vue&type=template&id=5b1ca3aa&scoped=true&"
import script from "./AgentSubTitle.vue?vue&type=script&lang=js&"
export * from "./AgentSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./AgentSubTitle.vue?vue&type=style&index=0&id=5b1ca3aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ca3aa",
  null
  
)

export default component.exports